import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const IdleTimeoutWarning = () => {
  const { isWarningActive, secondsRemaining, resetIdleTimer, logout } = useAuth();

  if (!isWarningActive) return null;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(15, 17, 23, 0.85)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      fontFamily: "'Inter', sans-serif"
    }}>
      <div style={{
        backgroundColor: '#1a1d26',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '400px',
        width: '90%',
        boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
        border: '1px solid rgba(44, 123, 229, 0.2)',
        textAlign: 'center'
      }}>
        <div style={{
          width: '64px',
          height: '64px',
          backgroundColor: 'rgba(44, 123, 229, 0.1)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
          color: '#2c7be5'
        }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        
        <h2 style={{ color: '#fff', fontSize: '1.5rem', marginBottom: '12px', fontWeight: 600 }}>
          Session Expiring
        </h2>
        
        <p style={{ color: '#aaa', fontSize: '1rem', lineHeight: '1.5', marginBottom: '24px' }}>
          You have been inactive for a while. For your security, you will be automatically logged out in:
        </p>
        
        <div style={{
          fontSize: '2.5rem',
          fontWeight: 700,
          color: '#2c7be5',
          marginBottom: '32px',
          fontVariantNumeric: 'tabular-nums'
        }}>
          {formatTime(secondsRemaining)}
        </div>
        
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={logout}
            style={{
              flex: 1,
              padding: '12px',
              borderRadius: '8px',
              border: '1px solid #333',
              backgroundColor: 'transparent',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '0.95rem',
              fontWeight: 500,
              transition: 'all 0.2s'
            }}
          >
            Logout Now
          </button>
          <button
            onClick={resetIdleTimer}
            style={{
              flex: 1,
              padding: '12px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: '#2c7be5',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '0.95rem',
              fontWeight: 500,
              boxShadow: '0 4px 12px rgba(44, 123, 229, 0.3)',
              transition: 'all 0.2s'
            }}
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
};

export default IdleTimeoutWarning;
